/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo } from 'react';

import { Box, Divider, Skeleton } from '@mui/material';

import { useBackupsConfigureStyles } from '../../../../../../styles/backupsConfigure';

export const SkeletonBackupsContinuous = memo(() => {
  const classes = useBackupsConfigureStyles();

  return (
    <div className={classes.root}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <div>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Skeleton variant="rounded" width="40px" height="18px" sx={{ borderRadius: '20px', mr: '20px' }} />{' '}
            {/* Skeleton Switch element */}
            <Skeleton variant="text" width="244px" sx={{ fontSize: '20px' }} />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', mt: '16px' }}>
            <Skeleton variant="rounded" width="200px" height="48px" sx={{ borderRadius: '6px', mr: '16px' }} />
            <Skeleton variant="rounded" width="200px" height="48px" sx={{ borderRadius: '6px' }} />
          </Box>
          <Divider component="div" sx={{ mt: '16px', mb: '16px', maxWidth: '611px' }} />
          <Box sx={{ display: 'flex' }}>
            <div>
              <Skeleton variant="text" width="166px" sx={{ fontSize: '16px' }} />
              <Box sx={{ mt: '5px', ml: '5px' }}>
                <Skeleton variant="text" width="290px" sx={{ fontSize: '14px' }} />
                <Skeleton variant="text" width="290px" sx={{ fontSize: '14px' }} />
              </Box>
            </div>
            <div style={{ marginLeft: '20px' }}>
              <Skeleton variant="text" width="203px" sx={{ fontSize: '16px' }} />
              <Box sx={{ mt: '5px', ml: '5px' }}>
                <Skeleton variant="text" width="290px" sx={{ fontSize: '14px' }} />
                <Skeleton variant="text" width="290px" sx={{ fontSize: '14px' }} />
              </Box>
              <Skeleton variant="text" width="208px" sx={{ fontSize: '14px', mt: '12px', ml: '5px' }} />
            </div>
          </Box>
        </div>
      </Box>
    </div>
  );
});
